import { Injectable } from "@angular/core";
import { HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";

export interface LstVersionResponse {
    id: number;
    version: string;
    lpm: string;
    urlWin: string;
    urlMac: string;
    urlLin: string;
}

@Injectable({
    providedIn: "root",
})
export class LstService extends DMSBaseService {
    constructor(public provider: ServiceProvider) {
        super("/lst", provider);
    }

    getVersion(lpm: string) {
        return this.getRecord(`/version/${lpm}`);
    }

    /** Installer via API, with progress. */
    downloadInstaller(lpm: string, os: 'windows' | 'mac' | 'linux'): Observable<HttpEvent<Blob>> {
        return this.downloadWithProgress(`/installer/${lpm}/${os}`);
    }
}
